import styled from 'styled-components';
import Hr from '.';

export default styled(Hr)`
	margin: 0;
	height: unset;
	min-height: unset;
	width: var(--border-width-small);
	min-width: var(--border-width-small);
`;
